const WALLET = {
  LOADING: 'WALLET_LOADING',
  FETCH_SUCCESS: 'WALLET_FETCH_SUCCESS',
  FETCH_FAILED: 'WALLET_FETCH_FAILED'
};

const SHOPIFY = {
  STORE_AUTH_DATA: 'SHOPIFY_STORE_AUTH_DATA',
  CLEAR_AUTH_DATA: 'SHOPIFY_CLEAR_AUTH_DATA',
  IS_SHOW_ALERT: 'SHOPIFY_IS_SHOW_ALERT'
};

const TICKET = {
  UNREAD_COUNT: "TICKET_UNREAD_COUNT",
};

export { WALLET, SHOPIFY, TICKET };
